import * as z from "zod";

const schema = z.object({
	isAreaBlock: z.boolean(),
	managerId: z.optional(z.string()),
	appliedDate: z.string(),
	endDate: z.optional(z.string()),
	taxAccountantIds: z.array(z.string())
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantModifyManagerResModel = { schema, model };
export type ITaxAccountantModifyManagerResModel = z.infer<typeof TaxAccountantModifyManagerResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_MODIFY_MANAGER_RES: ITaxAccountantModifyManagerResModel = {
	isAreaBlock: false,
	managerId: "",
	appliedDate: "",
	endDate: "",
	taxAccountantIds: []
};
